import { faSearch, faUndo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import EmptyState from '../../../shared/empty_state';
import PropTypes from 'prop-types';

export default function LeadNoResults({ onClearFilters }) {
  return (
    <EmptyState
      bodyText="Search with different criteria or reset filters"
      buttonIcon={faUndo}
      buttonText="Reset Filters"
      header="No results found"
      icon={faSearch}
      onClick={onClearFilters}
    />
  );
}

LeadNoResults.propTypes = {
  onClearFilters: PropTypes.func.isRequired
};
